import PublicLayout from "@/components/layout/PublicLayout";
import SEO from "@/components/SEO";
import LeadForm from "@/components/LeadForm";
import { Reveal } from "@/components/motion";
import { ShieldCheck } from "lucide-react";

export default function Consultation() {
  return (
    <PublicLayout>
      <SEO title="Free YouTube Campaign Consultation | NewStarAds" description="Request a free, no-obligation YouTube marketing consultation. Tell us about your channel and goals and get honest, tailored advice from the NewStarAds team." />
      <section className="max-w-6xl mx-auto px-5 sm:px-8 py-16 grid lg:grid-cols-2 gap-14 items-start">
        <Reveal>
          <p className="text-xs uppercase tracking-widest font-semibold text-primary">Free consultation</p>
          <h1 className="mt-3 font-display font-black text-4xl md:text-5xl tracking-tighter">Let's plan your YouTube campaign</h1>
          <p className="mt-5 text-lg text-slate-600 leading-relaxed">Share a few details about your channel and goals. Our team will review and reach out with honest, tailored recommendations — never a pushy sales pitch or guaranteed-view promises.</p>
          <div className="mt-8 rounded-2xl border border-slate-200 bg-slate-50 p-5 flex items-start gap-3">
            <ShieldCheck className="w-5 h-5 text-primary shrink-0 mt-0.5" />
            <p className="text-sm text-slate-600">Your information is kept private and secure. We never sell data or send spam, and we only run compliant promotion — no bots or fake engagement.</p>
          </div>
        </Reveal>
        <Reveal delay={0.1} className="rounded-2xl border border-slate-200 bg-white p-6 sm:p-8 shadow-sm">
          <LeadForm />
        </Reveal>
      </section>
    </PublicLayout>
  );
}
